import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Select from "react-select";
import { 
  GraduationCap, 
  BookOpen, 
  Globe, 
  FileCheck, 
  Briefcase, 
  Award, 
  Users, 
  Handshake, 
  Building2, 
  RotateCcw 
} from "lucide-react";

import OfferPresencial from "./view/OfferPresencial";
import OfferPosgrados from "./view/OfferPosgrados";
import OfferTec from "./view/OfferTecnologias";
import OfferTec2 from "./view/OfferTecnologiaSemestral";
import OfferFormacionPermanente from "./view/OfferFormacionPermanente";
import OfferLinea from "./view/OfferLinea";

 


// Estilos reutilizables para las tarjetas de ingreso
const cardStyles =
  "bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:shadow-md hover:border-slate-300 transition-all duration-200 flex flex-col items-center text-center group";

const iconContainerStyles =
  "w-12 h-12 rounded-xl bg-blue-50 text-[#004270] flex items-center justify-center mb-4 group-hover:bg-[#004270] group-hover:text-white transition-colors duration-200";

export default function BlockAcademicOffer({ data = {} }) {
  const [selectedNivel, setNivel] = useState(null);

  const options = [
    { value: "1", label: "Carreras a distancia y en línea" },
    { value: "2", label: "Carreras presencial" },
    { value: "4", label: "Tecnologías" },
    { value: "3", label: "Posgrados" },
    { value: "0", label: "-" },
  ];

  const handleChangeNivel = (selectedOption) => {
    setNivel(selectedOption ? selectedOption.value : null);
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "0.75rem",
      borderColor: state.isFocused ? "#004270" : "#cbd5e1",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 66, 112, 0.1)" : "none",
      padding: "0.35rem",
      "&:hover": { borderColor: "#004270" },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#004270" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      fontWeight: state.isSelected ? "bold" : "normal",
      cursor: "pointer",
    }),
  };

  return (
    <div className="w-full">
      {/* 1. SECCIÓN: SELECTOR DE NIVEL DE FORMACIÓN */}
      <section className="py-4 px-4  ">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 mb-4 max-w-xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-blue-50 text-[#004270] flex items-center justify-center shrink-0">
              <GraduationCap className="w-6 h-6" />
            </div>
            <h4 className="m-0 p-0 uppercase text-sm">Nivel de formación</h4>
          </div>
          
          <div className="text-left z-20">
            <Select
              value={options.find((o) => o.value === selectedNivel) || null}
              onChange={handleChangeNivel}
              options={options}
              placeholder="Selecciona un nivel..."
              styles={customSelectStyles}
              isSearchable={false}
            />
          </div>

          {!selectedNivel && (
            <motion.div
              key="empty"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
                   >
              <p  className="text-xs text-left mt-2 text-slate-400">
                Selecciona un nivel de formación en el menú desplegable superior para ver los programas.
              </p>
            </motion.div>
          )}
        </div>

        {/* Contenedor dinámico con transiciones para las ofertas */}
        <div className="transition-all duration-300 mt-8">
          <AnimatePresence mode="wait">
            {selectedNivel === "1" && (
              <motion.div key="linea" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }}>
                <OfferLinea />
              </motion.div>
            )}

            {selectedNivel === "2" && (
              <motion.div key="presencial" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }}>
                <OfferPresencial />
              </motion.div>
            )}

            {selectedNivel === "3" && (
              <motion.div key="posgrados" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }}>
                <OfferPosgrados />
              </motion.div>
            )}

            {selectedNivel === "4" && (
              <motion.div key="tecnologias" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }} className="space-y-8">
                <OfferTec />
                <OfferTec2 />
              </motion.div>
            )}

            {selectedNivel === "5" && (
              <motion.div key="permanente" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -15 }}>
                <OfferFormacionPermanente />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </section>
 
    </div>
  );
}